import type { ReceiptTemplate } from '../schema';

export const krogerTemplate: ReceiptTemplate = {
  id: 'kroger',
  name: 'Kroger Receipt',
  brand: 'KROGER',
  description: 'Kroger grocery store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'kroger-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/kroger.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #489',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'kroger-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'CASHIER: MIKE W.\n01/04/2026 2:45 PM',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'kroger-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'MILK 2% GALLON', quantity: '1', price: '4.99', sku: '' },
          { id: '2', name: 'BREAD WHEAT', quantity: '1', price: '3.49', sku: '' },
          { id: '3', name: 'EGGS LARGE DZ', quantity: '1', price: '5.99', sku: '' },
          { id: '4', name: 'BANANAS', quantity: '1', price: '1.29', sku: '' },
          { id: '5', name: 'CHICKEN BREAST', quantity: '1', price: '8.99', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'kroger-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '24.75', isBold: false, isLarge: false },
          { id: 'savings', label: 'KROGER PLUS SAVINGS', value: '-2.50', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '0.45', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '22.70', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'kroger-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'kroger-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'KROGER PLUS CARD\nYOU SAVED $2.50 TODAY!\n\nTHANK YOU FOR SHOPPING',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

